import React from 'react';
import { useLayout, useLayoutDispatch, useUISettings, useUISettingsDispatch } from './UISettingsProvider';
import { getLabel } from './data/labels';

function SettingsButtons(props) {
    const uiSettings = useUISettings();
    const uiSettingsDispatch = useUISettingsDispatch();
    const layout = useLayout();
    const layoutDispatch = useLayoutDispatch();
    const layoutType = layout.type;

    function setLayoutType(type) {
        layoutDispatch({
            type: 'setLayout',
            layout: type
        })
    }

    function toggleFullscreen() {
        uiSettingsDispatch({type: 'toggleFullscreen'});
    }

    return (
        <div className="toolbox-submenu">
            <div className="sposta-sidebar padding-verticale bg-colore-1 padding-orizzontale bordo-tondo">
                <span className="pointer bianco margine-dx" id="tasto-mescola-sb"><i className="fas fa-chevron-left ruota" id="freccia-ruota-sb"></i></span>
                <div className={"sposta-sb pointer " + (layoutType === 'sb-1' ? 'attivo-sb' : 'tasto-sb-nascosta sposta-sb-nasc')} onClick={() => setLayoutType('sb-1')} id="sposta-sb-1"></div>
                <div className={"sposta-sb pointer " + (layoutType === 'sb-2' ? 'attivo-sb' : 'tasto-sb-nascosta sposta-sb-nasc')} onClick={() => setLayoutType('sb-2')} id="sposta-sb-2"></div>
                <div className={"sposta-sb pointer " + (layoutType === 'sb-3' ? 'attivo-sb' : 'tasto-sb-nascosta sposta-sb-nasc')} onClick={() => setLayoutType('sb-3')} id="sposta-sb-3"></div>
            </div>
            {uiSettings.fullScreen ?
                <div className="tool-scroll bg-grigio bianco bordo-tondo pointer" onClick={toggleFullscreen} id="due-colonne-main">
                    <i className="fas fa-compress-arrows-alt"></i>
                    <span>{getLabel('general.4_col')}</span>
                </div>
                :
                <div className="tool-scroll bg-grigio bianco bordo-tondo pointer" onClick={toggleFullscreen} id="una-colonna-main">
                    <i className="fas fa-expand-arrows-alt"></i>
                    <span>{getLabel('general.3_col')}</span>
                </div>
            }
        </div>
    );
}

export default SettingsButtons;